export const journalRoutePaths = {
  list: {
    path: 'journal',
    fullPath: '/journal',
  },
  new: {
    path: 'journal/new',
    fullPath: '/journal/new',
  },
  // TRAD-1966 — 정적 세그먼트라 detail의 'journal/:journalId'와 충돌 없음(react-router v6는
  // 정적 세그먼트를 동적 세그먼트보다 항상 우선 매칭).
  weeklyReport: {
    path: 'journal/weekly-report',
    fullPath: '/journal/weekly-report',
  },
  detail: {
    path: 'journal/:journalId',
    fullPath: (journalId: string | number) => `/journal/${journalId}`,
  },
  edit: {
    path: 'journal/:journalId/edit',
    fullPath: (journalId: string | number) => `/journal/${journalId}/edit`,
  },
};
